import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ISDealspaceDirectory,
  UserGeneralSettings,
} from '../../helper/Interfaces';

import { RootState } from '../store';

export interface IProps {
  directoryList: ISDealspaceDirectory[] | undefined;
  userInfo: UserGeneralSettings | undefined;
  isUserIMO: boolean;
}

const initialState: IProps = {
  directoryList: undefined,
  userInfo: undefined,
  isUserIMO: false,
};

export const directoryListSlice = createSlice({
  name: 'directoryAssets',
  initialState,
  reducers: {
    postDirectoryList: (
      state,
      action: PayloadAction<ISDealspaceDirectory[] | undefined>
    ) => {
      state.directoryList = action.payload;
    },
    postUserInfo: (
      state,
      action: PayloadAction<UserGeneralSettings | undefined>
    ) => {
      state.userInfo = action.payload;
    },
    postIsUserIMO: (state, action: PayloadAction<boolean>) => {
      state.isUserIMO = action.payload;
    },
  },
});

export const { postDirectoryList, postIsUserIMO, postUserInfo } =
  directoryListSlice.actions;

export const getdirectoryDetail = (state: RootState) =>
  state.directoryReducer.directoryList;

export const getUserInfo = (state: RootState) =>
  state.directoryReducer.userInfo;

export const getIsUserIMO = (state: RootState) =>
  state.directoryReducer.isUserIMO;

export default directoryListSlice.reducer;
